let obj = {
  statusData: [
    { label: '新建', value: 0 },
    { label: '待审批', value: 1 },
    { label: '已发布', value: 2 },
    { label: '已关闭', value: 3 },
    { label: '未通过', value: 4 },
  ],
  pubObjTypeData: [
    // 3. LSP系统：平台管理人员 4、LSP系统：监管人员 5、LSP系统：网点企业人员
    { label: '平台管理人员', value: 3 },
    { label: '监管人员', value: 4 },
    { label: '网点企业人员', value: 5 },
  ],
}
export default obj
